import { useState, useEffect } from 'react'
import axios from 'axios'
import { useLocation, Link } from 'react-router-dom'
import { PageTitle } from '../../../../_metronic/layout/core'
import { useDispatch } from 'react-redux'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from '../../../../setup'
import * as auth from '../../../../app/modules/auth/redux/AuthRedux'
import { NotificationManager } from 'react-notifications'
import { matchConsumerId } from '../../utility'
import { KTSVG, toAbsoluteUrl } from '../../../../_metronic/helpers'

export function TESTAPI() {
  const [data, setData] = useState('')
  const [copiedStates, setCopiedStates] = useState({
    domain: false,
    consumerId: false,
    jwt: false
  })
  const query = useLocation()
  const dispatch = useDispatch()
  const location = query.search || ''
  const Id = location.split('=')[1]
  const user: any = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as any
  const {
    user: {id},
  } = user
  const domain = 'try.clanmeeting.com';
  useEffect(() => {
    if (id) {
      matchConsumerId(id, dispatch, auth)
    }
  }, [id])

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL_BACKEND_LOCAL}/get-jwt-test/${Id}`)
      .then((response) => {
        setData(response.data.token)
      })
  }, [Id])

  const handleCopy = (text: string, type: 'domain' | 'consumerId' | 'jwt') => {
    navigator.clipboard.writeText(text)
    setCopiedStates(prev => ({ ...prev, [type]: true }))
    NotificationManager.success(`${type === 'jwt' ? 'JWT' : type === 'consumerId' ? 'Consumer ID' : 'Domain'} copied to clipboard!`, '', 3000)
    setTimeout(() => {
      setCopiedStates(prev => ({ ...prev, [type]: false }))
    }, 2000)
  }

  const downloadMeetingHTML = () => {
    const consumerId = location.split('=')[1] || 'test123'
    const htmlContent = `<!DOCTYPE html>
<html>
  <head>
    <title>My First Clan Meeting</title>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
  </head>
  <body>
    <div id="my-meeting" style="position: fixed; top: 0; left: 0; bottom: 0; right: 0; width: 100%; height: 100%; border: none; margin: 0; padding: 0; overflow: hidden; z-index: 99;"></div>

    <script src="https://cdn.clanmeeting.com/releases/api/conferencing/${process.env.REACT_APP_CLANMEETING_VERSION}/dist/clanmeeting.min.js"></script>

    <script>
      const domain = '${domain}';
      const consumerId = '${consumerId}';
      const optionalProperties = {
          jwt: '${data}',
          roomName: 'first-meeting',
      };
      const meeting = new ClanMeeting(domain, consumerId, optionalProperties);

      meeting.anonymizeDisplayName();

      window.onload = function() {
        meeting.start();
      };
      window.onunload = function() {
        meeting.end();
      };
    </script>
  </body>
</html>`

    const blob = new Blob([htmlContent], { type: 'text/html' })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = 'my-first-meeting.html'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)
    
    NotificationManager.success('Meeting HTML downloaded! Open it in your browser to start your first meeting.', '', 5000)
  }

  return (
    <div className='container py-8'>
      <style>{`
        .brand-card {
          background-color: #333;
          border: none;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }

        .brand-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 16px rgba(97, 78, 110, 0.2);
        }

        .copy-btn {
          background-color: rgba(255, 255, 255, 0.15);
          border: 1px solid rgba(255, 255, 255, 0.3);
          transition: background-color 0.2s ease;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0;
        }
        
        .copy-btn svg {
          fill: white !important;
          stroke: white !important;
        }

        .btn .svg-icon {
          margin: 0 !important;
        }

        .copy-btn:hover {
          background-color: rgba(255, 255, 255, 0.25);
        }

        .copy-btn.copied {
          background-color: rgba(34, 197, 94, 0.3);
          border-color: rgba(34, 197, 94, 0.5);
        }

        .code-box {
          border: 1px solid rgba(255, 255, 255, 0.2);
          background: none !important;
        }

        .info-card {
          background-color: #f8f9fa;
          border: 1px solid #e9ecef;
        }

        .btn-brand {
          background-color: #614e6e;
          color: white;
          border: none;
          transition: background-color 0.2s ease;
        }

        .btn-brand:hover {
          background-color: #4f3e5a;
          color: white;
        }

        .btn-brand:disabled {
          background-color: #8a7a94;
          opacity: 0.6;
        }

        .status-badge {
          display: inline-flex;
          align-items: center;
          padding: 8px 16px;
          background-color: #fff3cd;
          border: 1px solid #ffc107;
          border-radius: 6px;
          color: #856404;
          font-weight: 600;
          font-size: 14px;
          margin-top:-10px;
          margin-right: -10px;
        }

        .status-badge svg {
          margin-right: 8px;
        }

        .production-cta {
          background: linear-gradient(135deg, #614e6e 0%, #4f3e5a 100%);
          border: none;
          color: white;
          padding: 16px 24px;
          border-radius: 8px;
          transition: all 0.2s ease;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          font-weight: 600;
        }

        .production-cta:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 16px rgba(97, 78, 110, 0.3);
          color: white;
          text-decoration: none;
        }

        .info-text {
          color: #6c757d;
          line-height: 1.6;
        }

        .info-text a {
          color: #614e6e;
          text-decoration: none;
          font-weight: 600;
        }

        .info-text a:hover {
          text-decoration: underline;
        }
      `}</style>

      <div className='d-flex justify-content-between align-items-start mb-4'>
        <div>
          <PageTitle breadcrumbs={[]}>Test API Keys</PageTitle>
          <h4>Start Testing in 60 Seconds</h4>
        </div>
        <div className='status-badge'>
          <svg width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
            <path d='M22 11.08V12a10 10 0 1 1-5.93-9.14'/>
            <polyline points='22 4 12 14.01 9 11.01'/>
          </svg>
          Testing Mode
        </div>
      </div>

      {/* Quick Start Info Card */}
      <div className='row g-4 mb-4'>
        <div className='col-12'>
          <div className='info-card card rounded-3 p-6 shadow-sm'>
            <div className='d-flex align-items-start'>
              <div>
                <p className='info-text mb-3'>
                  <strong>You're in testing mode.</strong> Use the static JWT below for quick integration and testing. Note that testing environment doesn't support cloud recording and streaming. Only 5 participants per call are allowed. Every time you refresh this page, a new token will be generated with 4-hour validity.
                </p>
                <p className='info-text mb-0'>
                  <strong>Ready for production?</strong> Head to the{' '}
                  <Link to={`/ssh/api?consumerId=${Id}`}>API Keys Page</Link>
                  {' '}to download your private key and generate your own short-lived JWTs. Move to a scalable production environment.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='row g-4'>
        {/* Domain Card */}
        <div className='col-lg-6 col-12'>
          <div className='brand-card card rounded-3 p-6 shadow-sm'>
            <div className='d-flex justify-content-between align-items-start mb-4'>
              <div>
                <h5 className='text-white mb-2 fw-bold'>Domain</h5>
                <p className='text-white-50 mb-0'>Your API domain endpoint</p>
              </div>
              <button
                className={`copy-btn btn btn-sm rounded-circle ${copiedStates.domain ? 'copied' : ''}`}
                onClick={() => handleCopy(domain, 'domain')}
              >
                <KTSVG path='/media/icons/duotune/files/fil026.svg' className='svg-icon-2' />
              </button>
            </div>
            <div className='code-box rounded-2 p-4'>
              <code className='text-white fs-6 d-block' style={{wordBreak: 'break-all'}}>{domain}</code>
            </div>
          </div>
        </div>

        {/* Consumer ID Card */}
        <div className='col-lg-6 col-12'>
          <div className='brand-card card rounded-3 p-6 shadow-sm'>
            <div className='d-flex justify-content-between align-items-start mb-4'>
              <div>
                <h5 className='text-white mb-2 fw-bold'>Consumer ID</h5>
                <p className='text-white-50 mb-0'>Your unique identifier</p>
              </div>
              <button
                className={`copy-btn btn btn-sm rounded-circle ${copiedStates.consumerId ? 'copied' : ''}`}
                onClick={() => handleCopy(location.split('=')[1] || 'test123', 'consumerId')}
              >
                <KTSVG path='/media/icons/duotune/files/fil026.svg' className='svg-icon-2' />
              </button>
            </div>
            <div className='code-box rounded-2 p-4'>
              <code className='text-white fs-6'>{location.split('=')[1] || 'test123'}</code>
            </div>
          </div>
        </div>

        {/* JWT Card */}
        <div className='col-12'>
          <div className='brand-card card rounded-3 p-6 shadow-sm'>
            <div className='d-flex justify-content-between align-items-start mb-4'>
              <div>
                <h5 className='text-white mb-2 fw-bold'>Test JWT</h5>
                <p className='text-white-50 mb-0'>
                  Static test token for development. Valid for 4 hours. 
                  <span className='text-warning fw-semibold'> ⚠️ Not for production use.</span>
                </p>
              </div>
              {data && (
                <button
                  className={`copy-btn btn btn-sm rounded-circle ${copiedStates.jwt ? 'copied' : ''}`}
                  onClick={() => handleCopy(data, 'jwt')}
                >
                  <KTSVG path='/media/icons/duotune/files/fil026.svg' className='svg-icon-2' />
                </button>
              )}
            </div>
            {data ? (
              <>
                <div className='code-box rounded-2 p-4 mb-4' style={{maxHeight: '200px', overflowY: 'auto'}}>
                  <code className='text-white small' style={{wordBreak: 'break-all', whiteSpace: 'pre-wrap'}}>
                    {data}
                  </code>
                </div>
              </>
            ) : (
              <div className='text-center py-5'>
                <div className='spinner-border text-white mb-3' role='status'>
                  <span className='visually-hidden'>Loading...</span>
                </div>
                <p className='text-white mb-0'>Generating your test JWT token...</p>
              </div>
            )}
          </div>
        </div>

        {/* Create Meeting Card */}
        <div className='col-lg-6 col-12'>
          <div className='brand-card card rounded-3 p-6 shadow-sm h-100'>
            <div className='text-center d-flex flex-column h-100'>
              <div className='mb-4'>
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" className="mx-auto">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
              </div>
              <h4 className='text-white fw-bold mb-3'>Create Your First Meeting</h4>
              <p className='text-white-50 mb-4 flex-grow-1'>Download a pre-configured sample meeting page. An HTML file is used for demo. Imagine this is the page where you route your meeting participants when they click "Join Meeting" button on your app. Open this HTML file in multiple browser tabs to join as multiple participants.</p>
              <div className="d-flex align-items-center justify-content-center">
                <button
                  className='btn-brand btn btn-lg px-5 py-3 fw-semibold me-3'
                  onClick={downloadMeetingHTML}
                  disabled={!data}
                >
                  <svg width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' className='me-2' style={{verticalAlign: 'middle'}}>
                    <path d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4'/>
                    <polyline points='7 10 12 15 17 10'/>
                    <line x1='12' y1='15' x2='12' y2='3'/>
                  </svg>
                  Meeting HTML
                </button>

                <a href="https://clanmeeting.com/docs/video-api-integrations/reactjs/" title="ReactJS" target="_blank" rel="noopener noreferrer">
                  <img src={toAbsoluteUrl('/media/reactjs.png')} alt='ReactJS' width='32' height='32' className='me-2' />
                </a>
                <a href="https://clanmeeting.com/docs/video-api-integrations/react-native/" title="React Native" target="_blank" rel="noopener noreferrer">
                  <img src={toAbsoluteUrl('/media/react-native.png')} alt='React Native' width='32' height='32' className='me-2' />
                </a>
                <a href="https://clanmeeting.com/docs/video-api-integrations/flutter/" title="Flutter" target="_blank" rel="noopener noreferrer">
                  <img src={toAbsoluteUrl('/media/flutter.png')} alt='Flutter' width='32' height='32' />
                </a>
              </div>
              {!data && (
                <p className='text-white-50 mt-3 mb-0 small'>Waiting for JWT token...</p>
              )}
            </div>
          </div>
        </div>


        {/* Documentation Card */}
        <div className='col-lg-6 col-12'>
          <div className='brand-card card rounded-3 p-6 shadow-sm h-100'>
            <div className='text-center d-flex flex-column h-100'>
              <div className='mb-4'>
                <svg width='48' height='48' viewBox='0 0 24 24' fill='none' stroke='white' strokeWidth='2' className='mx-auto'>
                  <path d='M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z'/>
                  <polyline points='14 2 14 8 20 8'/>
                  <line x1='16' y1='13' x2='8' y2='13'/>
                  <line x1='16' y1='17' x2='8' y2='17'/>
                  <polyline points='10 9 9 9 8 9'/>
                </svg>
              </div>
              <h4 className='text-white fw-bold mb-3'>View Documentation</h4>
              <p className='text-white-50 mb-4 flex-grow-1'>Learn how to integrate and customize the API for your application</p>
              <a 
                href='https://clanmeeting.com/docs/video-api/getting-started/' 
                target='_blank' 
                rel='noopener noreferrer'
                className='btn-brand btn btn-lg px-5 py-3 fw-semibold text-decoration-none'
              >
                <svg width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' className='me-2' style={{verticalAlign: 'middle'}}>
                  <path d='M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6'/>
                  <polyline points='15 3 21 3 21 9'/>
                  <line x1='10' y1='14' x2='21' y2='3'/>
                </svg>
                Open Documentation
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}